import React from 'react';
import Button from '../Button';
import Config from '../../utils/Configuration';
import {pagePath} from '../../RouteConfig';
import {Link} from 'react-router-dom';

const NotFound = () => {
    return (
        <div className='not-found'>
            <div>
                <picture className='not-found-background'>
                    <source srcset='/images/404/breakerbanner-desktop.webp' media='(min-width: 1014px)' />
                    <source srcset='/images/404/breakerbanner-tablet.webp' media='(min-width: 768px)' />
                    <source srcset='/images/404/breakerbanner-mobile.webp' media='(min-width: 375px)' />
                    <img srcset='/images/404/breakerbanner-mobile.webp' />
                </picture>
                <div className='not-found-content container mb-50px mb-xl-7'>
                    <div className='rebrand' data-placeholder-text='Bootstrap Container: Drag components here'>
                        <div className='row justify-content-start align-items-center mt-30px'>
                            <div className='col-12 col-md-6 mt-md-4'>
                                <h1 className='notfound-title maxis-bold'>
                                    Hey there! This page is on a coffee break.
                                </h1>
                                <p>Let’s take you somewhere more accessible.</p>

                                <div className='d-flex flex-column flex-md-row justify-content-start mb-3 gap-2'>
                                    <Button
                                        href={'/'}
                                        buttonLabel={'Return to Homepage'}
                                        buttonClass='not-found-button'
                                        reactButtonClass='w-fit me-1'
                                        hoverAnim={false}
                                    ></Button>
                                    <Button
                                        href={Config.maxisBusinessSMELink}
                                        buttonLabel={'Check out the store'}
                                        buttonClass='not-found-button'
                                        reactButtonClass='w-fit'
                                        hoverAnim={false}
                                    ></Button>
                                </div>

                                <div className='pb-5 pb-lg-0 mb-5 mb-md-0'>
                                    <p>
                                        Or these might help instead:
                                        <br />
                                    </p>
                                    <ul className='mb-4'>
                                        <li>
                                            <a href={Config.maxisBusinessSupportLink} rel='noreferrer noopener'>
                                                Get Support
                                            </a>
                                        </li>
                                        <li>
                                            <a href={Config.maxisBusinessFAQLink} rel='noreferrer noopener'>
                                                FAQs
                                            </a>
                                        </li>
                                        <li>
                                            <a href={pagePath.infoCaptureUrl} rel='noreferrer noopener'>Coverage Checker</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
